import { Modal } from "antd";
import discord_members from "apps/dots-frontend/types/discord_members";
import { useContext, useEffect, useState } from "react";
import { GlobalModalContext } from "../components/GlobalModalContext/GlobalModalContext";
import MemberDetail from "../components/Members/MemberDetail";
import { AllMembers } from "./discordTypes";
import supabase from "./supabase";

interface SlackProps {
  member: { slack_id: string; name: string };
}
/**
 * A function that opens a modal with the details of a slack user
 * @param a member object with a name and slack_id (corresponding to name and slack_id in the slack users table)
 */
export function SlackMemberModal({ member }: SlackProps) {
  const { setGlobalModal } = useContext(GlobalModalContext);
  return (
    <Modal
      width={1200}
      title={member ? `${member.name}'s activity` : "Member activity"}
      style={{ top: 40, right: 10, borderRadius: 20 }}
      visible={true}
      onCancel={() => setGlobalModal(null)}
      footer={[]}
    >
      <MemberDetail slackUser={member} platform="slack" />
    </Modal>
  );
}

interface DiscordProps {
  userId: string;
}
/**
 * A function that opens a modal with a discord member's info
 * @param userId The ID of a discord member, same as the `id` column in the discord users table
 */
export function DiscordMemberModal({ userId }: DiscordProps) {
  const { setGlobalModal } = useContext(GlobalModalContext);
  const [fullMember, setFullMember] = useState<AllMembers>();

  useEffect(() => {
    (async () => {
      const { data: fullMember, error: fullMemberError } = await supabase
        .from("discord_members")
        .select(
          `id,
              *,
              discord_roles(discord_id, name),
              tags(id, name, color)`
        )
        .eq("id", userId)
        .limit(1)
        .single();
      if (fullMemberError) console.error(fullMemberError);
      setFullMember(fullMember);
    })();
  }, []);

  return (
    <Modal
      width={1200}
      title={
        fullMember ? `${fullMember.username}'s activity` : "Member activity"
      }
      style={{ top: 40, right: 10, borderRadius: 20 }}
      visible={true}
      onCancel={() => setGlobalModal(null)}
      footer={[]}
    >
      {fullMember && (
        <MemberDetail discordUser={fullMember} platform="discord" />
      )}
    </Modal>
  );
}
